import { render, staticRenderFns } from "./GrowtradeResetPassword.vue?vue&type=template&id=00429e45&scoped=true&"
import script from "./GrowtradeResetPassword.vue?vue&type=script&lang=js&"
export * from "./GrowtradeResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./GrowtradeResetPassword.vue?vue&type=style&index=0&id=00429e45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00429e45",
  null
  
)

export default component.exports